<template>
  <div class="quiz-break-overlay">
    <div class="quiz-break-card">
      <p class="subtitle">The next assessment will begin shortly, please wait</p>
      <div id="timer" :key="timer.sec" class="timer">
        <span class="clock_boxs">
          <span class="clock_box1">{{ timer.min }}&nbsp;Min&nbsp;</span>
          <span class="colon">:</span>
          <span class="clock_box2">{{ timer.sec }}&nbsp;Sec&nbsp;</span>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { socialvue } from "../../../config/pluginInit"
import { AppChains } from "../../../FackApi/api/AppChain"

export default {
  name: "QuizBreakTimer",
  data () {
    return {
      breakTimeDurationInSecs: 0,
      timer: { min: 0, sec: 0 },
      breakDuration: 10, // default break duration in seconds
      timerFunctionRef: null,
      nextQuizId: null
    }
  },
  mounted () {
    socialvue.index()
    this.nextQuizId = this.$route.params.nextQuizId
    this.getBreakTimeDuration()
  },
  methods: {
    /**
     * getBreakTimeDuration
     */
    async getBreakTimeDuration () {
      try {
        const payload = {
          chain_to: this.$route.params.nextQuizId
        }
        const appChainViewResp = await AppChains.AppChainView(this, payload)
        // console.log(appChainViewResp?.resp_data?.data?.break_before_chain_to, "appChainViewResp ", appChainViewResp)

        if (!appChainViewResp?.resp_status || appChainViewResp?.resp_data?.count == 0 || !appChainViewResp?.resp_data?.data?.break_before_chain_to) {
          // Timer Not set or data not found, go to next quiz directly
          this.$router.replace(`/quiz_detail/${this.nextQuizId}`)
          return
        }

        this.breakDuration = appChainViewResp.resp_data.data.break_before_chain_to // In Minutes

        this.timer.min = parseInt(parseInt(this.breakDuration))
        this.timer.sec = parseInt(parseInt(this.breakDuration) * 60)

        this.startTimer()
      }
      catch (err) {
        console.error("Exception in getBreakTimeDuration() and err: ", err.message)
      }
    },

    /**
     * startTimer
     */
    startTimer () {
      this.timer.sec = this.timer.sec - 1
      if (this.timer.sec < 10 && this.timer.sec >= 0) { this.timer.sec = "0" + this.timer.sec } // add zero in front of numbers < 10
      if (this.timer.sec < 0) { this.timer.sec = "59" }

      // console.error("timer.sec: ", parseInt(this.timer.sec), "type: ", typeof parseInt(this.timer.sec), "timer.min: ", this.timer.min)
      if (parseInt(this.timer.sec) == 59) { this.timer.min = parseInt(this.timer.min) - 1 }

      if (this.timer.min < 0 && this.timer.sec < 60) {
        // Time Out redirect to the next quiz
        this.goToNextQuiz()
        return
      }
      this.timerFunctionRef = setTimeout(this.startTimer, 1000)
    },
    /**
     * goToNextQuiz
     */
    goToNextQuiz () {
      // Timer times out so clear the setTimeout function
      clearTimeout(this.timerFunctionRef)
      this.$router.replace(`/quiz_detail/${this.nextQuizId}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.quiz-break-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7); // dark transparent overlay
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.quiz-break-card {
  background: #fff;
  padding: 2rem 3rem;
  border-radius: 1rem;
  text-align: center;
  box-shadow: 0 4px 25px rgba(0, 0, 0, 0.2);
  max-width: 500px;
  width: 100%;
}

.title {
  font-size: 1.5rem;
  color: #222;
  margin-bottom: 0.5rem;
}

.subtitle {
  font-size: 1rem;
  color: #555;
  margin-bottom: 1.2rem;
}

.timer {
  font-size: 1.25rem;
  color: #e5252c;
}

.clock_boxs {
  display: flex;
  justify-content: center;
  align-items: center;
}

.clock_box1,
.clock_box2 {
  padding: 0 5px;
}

.colon {
  margin: 0 4px;
}
</style>
